export default () => {
  return {
    appUpdateInfo: null,
  };
};
